export function dateParse(date, withTime = false) {
  const currentDate = new Date(date)
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth() + 1
  const day = currentDate.getDate()

  const hour = currentDate.getHours()
  const minutes = currentDate.getMinutes()
  const seconds = currentDate.getSeconds()

  let formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day
    }`
  if (withTime) {
    formattedDate = formattedDate + ` ${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }
  return formattedDate
}

export function dateSpanishFormatter(fecha, withTime = false) {
  // Crear un objeto de fecha a partir de la cadena de fecha
  const date = new Date(fecha)

  // Obtener los componentes de fecha y hora
  const dia = date.getDate()
  const mes = date.getMonth() + 1 // Los meses empiezan desde 0
  const anio = date.getFullYear()

  const hour = date.getHours()
  const minutes = date.getMinutes()

  // Formatear la fecha y hora en formato DD/MM/AAAA HH:MM
  let fechaFormateada = `${dia.toString().padStart(2, '0')}/${mes
    .toString()
    .padStart(2, '0')}/${anio}`

  if (withTime) {
    fechaFormateada = fechaFormateada + ` ${hour}:${minutes.toString().padStart(2, '0')}`
  }

  return fechaFormateada
}

export function dateISO(date) {

  if(date!=null){
    const objectDate = new Date(date)
    return objectDate.toISOString()
  }

}